import { render, staticRenderFns } from "./PageItem.vue?vue&type=template&id=2a38776c&scoped=true&"
import script from "./PageItem.vue?vue&type=script&lang=js&"
export * from "./PageItem.vue?vue&type=script&lang=js&"
import style0 from "./PageItem.vue?vue&type=style&index=0&id=2a38776c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a38776c",
  null
  
)

export default component.exports